import React from 'react';
import PropTypes from 'prop-types';
import {
    Flex,
    Text,
    Tooltip,
    TooltipPopper,
} from '@zillow/constellation';

import numberUtils from 'app/shared/utils/numberUtils';

import ConnectedNetworkView from 'app/shared/components/ConnectedNetworkView';
import PropertyConstants from 'app/shared/constants/PropertyConstants';

import {
    StyledFlexPriceOnlyContainer,
    StyledMobileOnlyVerticalDivider,
    StyledVerticalDivider,
    StyledPriceTag,
    StyledWeek,
} from 'app/shared/components/ConnectedListingFooter/components/AdditionalInformation/StyledComponents';

const { SYNDICATION_OVERVIEW_STATUS } = PropertyConstants;

const propTypes = {
    isMobile: PropTypes.bool.isRequired,
    price: PropTypes.number,
    hidePrice: PropTypes.bool,
    syndication: PropTypes.object.isRequired,
    unitOfMeasure: PropTypes.string,
};

const defaultProps = {
    price: null,
    hidePrice: false,
    unitOfMeasure: '',
};

const FeedConnectAdditionalInformation = ({
    isMobile,
    price,
    hidePrice,
    syndication,
    unitOfMeasure,
}) => {
    const { overview: { status } } = syndication;
    const formattedPrice = numberUtils.asCurrencyWithDefault(price, '-');

    let priceText = '';

    if (unitOfMeasure === 'day') {
        priceText = `If you publish this listing, you’ll be billed ${formattedPrice} per day,
            the rate in your Feed Connect™ contract.`;
    } else if (unitOfMeasure === 'month') {
        priceText = `If you publish this listing, it will be added to your monthly invoice where you are charged
            ${formattedPrice}/month per average listing live in the month.`;
    }

    const tooltipContent = <Tooltip body={<Text fontType="bodySmall">{priceText}</Text>} />;

    const renderPriceComponent = () => {
        if (!price || hidePrice) {
            return null;
        }
        return (
            <StyledFlexPriceOnlyContainer>
                <Flex display="flex">
                    <StyledPriceTag>{formattedPrice}</StyledPriceTag>
                    &nbsp;
                    <StyledWeek as="span">
                        {`/${unitOfMeasure}`}
                    </StyledWeek>
                    &nbsp;
                    <TooltipPopper
                        triggered={tooltipContent}
                        placement="top"
                    />
                </Flex>
                <StyledMobileOnlyVerticalDivider />
            </StyledFlexPriceOnlyContainer>
        );
    };

    if (status === SYNDICATION_OVERVIEW_STATUS.DECLINED) {
        return renderPriceComponent();
    }

    if (status === SYNDICATION_OVERVIEW_STATUS.PARTIALLY_PUBLISHED) {
        return (
            <Flex display="flex" alignItems="center" flexGrow={1}>
                <StyledVerticalDivider />
                <ConnectedNetworkView
                    syndication={syndication}
                    label={`View published ${isMobile ? '' : 'listings'}`}
                />
            </Flex>
        );
    }

    if (status === SYNDICATION_OVERVIEW_STATUS.INACTIVE) {
        return renderPriceComponent();
    }

    return null;
};

FeedConnectAdditionalInformation.propTypes = propTypes;
FeedConnectAdditionalInformation.defaultProps = defaultProps;

export default FeedConnectAdditionalInformation;
